// Component for rendering measurement input sections
import { Grid, TextField, Typography } from "@mui/material";

export const SleeveSection = ({ formData, handleChange }) => (
  <>
    <Grid item xs={12} sx={{ mt: 2 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#666", mb: 1 }}>
        Sleeve Length
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Short Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.SleeveShortLength} onChange={(e) => handleChange("SleeveShortLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Short Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.SleeveShortRound} onChange={(e) => handleChange("SleeveShortRound", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Above Elbow Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.SleeveAboveElbowLength} onChange={(e) => handleChange("SleeveAboveElbowLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Above Elbow Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.SleeveAboveElbowRound} onChange={(e) => handleChange("SleeveAboveElbowRound", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="3/4th Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.Sleeve34Length} onChange={(e) => handleChange("Sleeve34Length", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="3/4th Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.Sleeve34Round} onChange={(e) => handleChange("Sleeve34Round", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Full Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.SleeveFullLength} onChange={(e) => handleChange("SleeveFullLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Full Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.SleeveFullRound} onChange={(e) => handleChange("SleeveFullRound", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Armhole Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.ArmholeRound} onChange={(e) => handleChange("ArmholeRound", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Biceps Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.BicepsLength} onChange={(e) => handleChange("BicepsLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Biceps Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.BicepsRound} onChange={(e) => handleChange("BicepsRound", e.target.value)} />
    </Grid>
  </>
);

export const BustSection = ({ formData, handleChange }) => (
  <>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Upper Bust Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.UpperBustLength} onChange={(e) => handleChange("UpperBustLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Upper Bust Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.UpperBustRound} onChange={(e) => handleChange("UpperBustRound", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Gap" type="number" inputProps={{ step: "0.01" }}
        value={formData.Gap} onChange={(e) => handleChange("Gap", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Bust Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.BustLength} onChange={(e) => handleChange("BustLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Bust Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.BustRound} onChange={(e) => handleChange("BustRound", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Under Bust Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.UnderBustLength} onChange={(e) => handleChange("UnderBustLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Under Bust Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.UnderBustRound} onChange={(e) => handleChange("UnderBustRound", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Stomach Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.StomachLength} onChange={(e) => handleChange("StomachLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Stomach Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.StomachRound} onChange={(e) => handleChange("StomachRound", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Lower Waist Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.LowerWaistLength} onChange={(e) => handleChange("LowerWaistLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Lower Waist Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.LowerWaistRound} onChange={(e) => handleChange("LowerWaistRound", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Hip Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.HipLength} onChange={(e) => handleChange("HipLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Hip Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.HipRound} onChange={(e) => handleChange("HipRound", e.target.value)} />
    </Grid>
  </>
);

export const LowerBodySection = ({ formData, handleChange }) => (
  <>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Lower Total Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.LowerTotalLength} onChange={(e) => handleChange("LowerTotalLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Plus Heels" type="number" inputProps={{ step: "0.01" }}
        value={formData.PlusHeels} onChange={(e) => handleChange("PlusHeels", e.target.value)} />
    </Grid>
    <Grid item xs={12}>
      <TextField fullWidth size="small" label="Lower Description" multiline rows={2}
        value={formData.LowerDescription} onChange={(e) => handleChange("LowerDescription", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Thighs Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.ThighsLength} onChange={(e) => handleChange("ThighsLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Thighs Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.ThighsRound} onChange={(e) => handleChange("ThighsRound", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Knees Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.KneesLength} onChange={(e) => handleChange("KneesLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Knees Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.KneesRound} onChange={(e) => handleChange("KneesRound", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Calf Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.CalfLength} onChange={(e) => handleChange("CalfLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Calf Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.CalfRound} onChange={(e) => handleChange("CalfRound", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Bottom Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.BottomLength} onChange={(e) => handleChange("BottomLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Bottom Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.BottomRound} onChange={(e) => handleChange("BottomRound", e.target.value)} />
    </Grid>

    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Seat Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.SeatRound} onChange={(e) => handleChange("SeatRound", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Ankle Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.AnkleLength} onChange={(e) => handleChange("AnkleLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Ankle Round" type="number" inputProps={{ step: "0.01" }}
        value={formData.AnkleRound} onChange={(e) => handleChange("AnkleRound", e.target.value)} />
    </Grid>
  </>
);

export const LengthMeasurementsSection = ({ formData, handleChange }) => (
  <>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Above Knee" type="number" inputProps={{ step: "0.01" }}
        value={formData.AboveKnee} onChange={(e) => handleChange("AboveKnee", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Below Knee" type="number" inputProps={{ step: "0.01" }}
        value={formData.BelowKnee} onChange={(e) => handleChange("BelowKnee", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Calf Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.MiddleFloorLength} onChange={(e) => handleChange("MiddleFloorLength", e.target.value)} />
    </Grid>

    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Ankle Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.AnkleLengthMeasure} onChange={(e) => handleChange("AnkleLengthMeasure", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Floor Length" type="number" inputProps={{ step: "0.01" }}
        value={formData.FloorLength} onChange={(e) => handleChange("FloorLength", e.target.value)} />
    </Grid>
    <Grid item xs={6} sm={4} md={3}>
      <TextField fullWidth size="small" label="Plus Heels" type="number" inputProps={{ step: "0.01" }}
        value={formData.PlusHeelsLength} onChange={(e) => handleChange("PlusHeelsLength", e.target.value)} />
    </Grid>
  </>
);
